export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-problem-2.a17e64d2.png";